/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import cn from 'classnames';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

import { PageHeader } from '../../../../app/components/PageHeader';
import CardComponent from '../../../containers/App/Components/Card/Card';
import LoadingCard from '../../../containers/App/Components/LoadingCard/LoadingCard';
import PaginationComponent from '../../../containers/App/Components/Pagination/Pagination';
import { ArrowDown, ChevronRight, Home, Sort, Car, Euro } from '../../../components/Icon';
import CheckboxComponent from '../../../containers/App/Components/Checkbox/Checkbox';
import { TransportOrderSearch } from '../components/Search';
import { RegplateLabel } from '../../Vehicles/components/RegplateLabel';
import { VehicleStatusLabel } from '../../Vehicles/components/VehicleStatusLabel';
import { HBox, VBox } from '../../../components/Box';
import { getDate, getVehicleTaskOpen } from '../../Vehicles/helpers';
import { WithVehicle } from '../../Vehicles/components/WithVehicle';
import LoadingFilters from '../../../containers/App/Components/LoadingFilters/LoadingFilters';

import {
  addTransportOrderToBulkActionsList,
  applyTransportOrderFilters,
  applyTransportOrderSeparateListFilters,
  changeTransportOrderFilter,
  removeTransportOrderFromBulkActionsList,
  setTransportOrdersSort,
  switchOverviewScreenMode,
} from '../actions';
import { setScrollPosition } from '../../Actions/actions';
import { toggleNotification } from '../../Companies/actions';

import {
  selectOverviewScreenMode,
  selectQuickSeparateFilter,
  selectSeparateListTransportOrderCount,
  selectSeparateListTransportOrderPaginator,
  selectTransportOrderCount,
  selectTransportOrderFilter,
  selectTransportOrderPaginator,
  selectTransportOrders,
  selectTransportOrdersBulkActionsList,
  selectTransportOrderSeparateListFilter,
  selectTransportOrdersSeparateList,
} from '../selectors';
import { selectWorks } from '../../Api/selectors';
import { REQUEST_TRANSPORT_ORDERS, SET_TRANSPORT_ORDERS_SORT } from '../constants';
import s from './overviewDoubleScreen.module.css';
import { BulkActionsTransportOrderCard } from './BulkActions/BulkActionsCard';

import { TransportOrderCreateModal } from '../components/createTransportOrder';
import ButtonComponent from '../../../containers/App/Components/Button/Button';
import { TransportOrdersOverviewMaps } from './overviewMaps';
import { parseCompanyPhoneNumber } from '../helpers';
import { OnMouseOverNotification } from '../../Vehicles/components/OnMouseOverNotification';

dayjs.extend(customParseFormat);

const STATE = {
  sort: null,
  sort_direction: 'down',
  isShowAddModal: false,
  isShowMore: true,
  currentPage: 0,
  localPaginator: {
    limit: 50,
    offset: 0,
    itemsCount: 0,
  },
  filteredVehicles: [],
};

/* eslint-disable react/prefer-stateless-function */
class TransportOrdersOverviewDoubleScreenComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
      isTableView: false,
      isTableView2: false,
      showModal: false, // New state to manage modal visibility
      selectedTransportOrder: null, // Store the selected transport order
    });
  }

  toggleView = () => {
    this.setState(prevState => ({
      isTableView: !prevState.isTableView,
    }));
  };
  toggleView2 = () => {
    this.setState(prevState => ({
      isTableView2: !prevState.isTableView2,
    }));
  };

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState) {}

  get transportOrders() {
    if (this.props.weblogin && Array.isArray(this.state.filteredTransportOrders)) {
      return this.state.filteredTransportOrders;
    }

    return this.props.weblogin ? this.props.webloginVehicles : this.state.filteredTransportOrders;
  }

  get locationState() {
    return this.props.location?.state?.state;
  }

  get noSortingTypes() {
    return [
      'isHome',
      'regplate',
      'from_address',
      'to_address',
      'financial_info',
      'from_company',
      'to_company',
      'transporter',
      'direction',
      'type',
    ];
  }

  renderVehiclePaymentStatus(type, vehicle) {
    if (type === 'incoming') {
      return vehicle.incoming_invoice_payment_status ? (
        <span style={{ color: 'green' }}>
          <Euro />
        </span>
      ) : (
        !vehicle.incoming_invoice_payment_status && (
          <span style={{ color: 'red' }}>
            <Euro />
          </span>
        )
      );
    }
    if (type === 'outgoing') {
      return vehicle.outgoing_invoice_payment_status == 'PAID' ? (
        <span style={{ color: 'green' }}>
          <Euro />
        </span>
      ) : vehicle.outgoing_invoice_payment_status == 'PARTLY_PAID' ? (
        <span style={{ color: 'black' }}>
          <Euro />
        </span>
      ) : (
        <span style={{ color: 'red' }}>
          <Euro />
        </span>
      );
    }

    return '';
  }
  renderReleaseStatus(type, vehicle) {
    if (type === 'incoming') {
      return vehicle.regplate && vehicle.orb_incoming_complete ? (
        <span style={{ color: 'green' }}>
          <Car />
        </span>
      ) : (
        vehicle.regplate && !vehicle.orb_incoming_complete && (
          <span style={{ color: 'red' }}>
            <Car />
          </span>
        )
      );

      // <VehicleStatusLabel width={'80px'} color={vehicle?.orb_incoming_complete ? '#15AC79' : 'red'} overview={'double'}>
      //   {vehicle?.orb_incoming_complete ? 'Vrijwaring' : 'Vrijwaring'}
      // </VehicleStatusLabel>
    }
    return '';
  }

  getTypesTosort(type) {
    let types = {
      info: 'model_name',
    };

    return types[type] || type;
  }

  sortOn(field, option) {
    if (this.noSortingTypes?.includes(field)) {
      return;
    }

    let direction = 'none';
    let sortType;
    const filter = option === 'separateList' ? this.props.separateListFilter : this.props.filter;

    switch (field) {
      case 'info': {
        sortType = 'model_name';
        break;
      }

      default:
        sortType = field;
    }

    let order;
    if (filter?.sortType == sortType) {
      if (!filter?.order) order = 'asc';
      if (filter?.order == 'asc') order = 'desc';
    } else {
      order = 'asc';
    }
    this.setState({ direction: !order ? 'none' : order == 'asc' ? 'up' : 'down' });
    order ? this.props.setSort(sortType, order, option) : this.props.setSort('', '', option);
  }

  selectPage = (newPage, option) => {
    const paginator = option == 'separateList' ? this.props.separateListPaginator : this.props.paginator;
    const newOffset = newPage * paginator?.limit ?? 0;
    this.props.setScrollPosition(null);

    this.setState(
      prev => ({
        currentPage: newPage,
      }),
      this.props.changeFilter('offset', newOffset, { separateList: option == 'separateList' ? true : null }),
    );
  };

  cols() {
    return [
      // 'regplate',

      'info',
      'financial_info',
      'from_company',

      // 'from_address',
      'to_company',
      // 'to_address',
      // 'transporter',
      //'datePlanned',
      'dateToPlan',
      'direction',
      'type',
      // 'plan',
    ];
  }

  toggleDiv = () => {
    this.setState(prevState => ({
      isShowMore: !prevState.isShowMore,
    }));
  };

  isSelectedTransportOrder(transportOrderId) {
    return this.props.bulkActionsList?.filter(item => item?.id === transportOrderId)?.length == 1;
  }

  onSelectTransportOrder(e, transportOrder) {
    e.stopPropagation();

    if (this.isSelectedTransportOrder(transportOrder?.id)) {
      return this.props.removeTransportOrderFromBulkActionsList(transportOrder?.id);
    }
    return this.props.addTransportOrderToBulkActionsList(transportOrder);
  }

  onSelectAll(e, transportOrders) {
    e.stopPropagation();
    return transportOrders?.filter(transportOrder => this.props.addTransportOrderToBulkActionsList(transportOrder));
  }

  onRemoveAll(e, transportOrders) {
    e.stopPropagation();
    return transportOrders?.filter(transportOrder => this.props.removeTransportOrderFromBulkActionsList(transportOrder?.id));
  }

  filterTransportOrders = filterParams => {
    if (!filterParams) {
      this.setState({ filteredTransportOrders: this.props.webloginVehicles || [] });
      return;
    }

    const filters = filterParams.properties.reduce((acc, cur) => {
      if (cur.key === 'status') {
        acc[cur.key] = cur.value;
      } else {
        acc[cur.key] = cur.value.map(v => v.toLowerCase());
      }
      return acc;
    }, {});

    const searchString = filterParams.searchString ? filterParams.searchString.toLowerCase() : '';
    const searchWords = searchString.split(/\s+/);

    if (!this.props.webloginVehicles) {
      this.setState({ filteredVehicles: [] });
      return;
    }

    const filteredVehicles = this.props.webloginVehicles.filter(vehicle => {
      const vehicleStatus = vehicle.status;

      const matchesFilters = Object.keys(filters).every(key => {
        if (key === 'status') {
          return filters[key].length === 0 || filters[key].includes(vehicleStatus);
        } else {
          const vehicleProperty = vehicle[key] ? vehicle[key].toLowerCase() : '';
          return filters[key].length === 0 || filters[key].some(filterValue => vehicleProperty.includes(filterValue));
        }
      });

      const matchesSearchString =
        searchWords.length === 0 ||
        searchWords.every(word =>
          ['brand_name', 'model_name', 'id', 'regplate', 'vin'].some(prop =>
            vehicle[prop]
              ? vehicle[prop]
                  .toString()
                  .toLowerCase()
                  .includes(word)
              : false,
          ),
        );

      return matchesFilters && matchesSearchString;
    });

    this.setState({ filteredVehicles });
  };

  render() {
    if (this.props.work)
      return (
        <>
          <PageHeader
            title={
              <>
                <Home />
                {this.lbl('transport_order.overview.title')}
                {this.props.count !== null ? <span className="label number">{this.props.count}</span> : null}
              </>
            }
            breadCrumbs={
              <>
                <a href="/">Vindat</a>
                <ChevronRight />
                {this.lbl('transport_order.overview.title')}
              </>
            }
          />
          <LoadingFilters />
        </>
      );
    {
      console.log('Modal State: ', this.state.showModal, this.state.selectedTransportOrder);
    }

    const transportOrders = this.props.transportOrders;
    const transportOrdersSecondList = this.props.transportOrdersSeparateList ?? [];
    const { localPaginator } = this.state;
    const {
      currentPage,
      localPaginator: { limit },
    } = this.state;

    const transportOrdersToShow = transportOrders ?? [];

    return (
      <div className="container-fluid p-0">
        {!!this.props.bulkActionsList?.length && (
          <BulkActionsTransportOrderCard bulkActionsList={this.props.bulkActionsList} />
        )}
        <PageHeader
          title={
            <>
              <Home />
              {this.lbl('transport_order.overview.title')}
              {this.props.count !== null ? <span className="label number">{this.props.count}</span> : null}
            </>
          }
          breadCrumbs={
            <>
              <a href="/">Vindat</a>
              <ChevronRight />
              {this.lbl('transport_order.overview.title')}
            </>
          }
        ></PageHeader>

        <HBox>
          <VBox>
            <div className="d-flex gap-2">
              <div>
                <HBox right>
                  <ButtonComponent style={'ButtonSoftPrimary'} onClick={this.toggleView}>
                    {this.state.isTableView ? this.lbl('transport.show_column') : this.lbl('transport.show_card')}
                  </ButtonComponent>
                </HBox>
                <TransportOrderSearch overview={'double'} />
              </div>
              <div>
                <HBox right style={{ gap: '10px' }}>
                  {' '}
                  {/* Adjust the value as needed */}
                  <ButtonComponent style={'ButtonSoftPrimary'} onClick={() => this.props.switchScreen()}>
                    {this.props.doubleScreen ? this.lbl('transport.single') : this.lbl('transport.double')}
                  </ButtonComponent>
                  <ButtonComponent style={'ButtonSoftPrimary'} onClick={this.toggleView2}>
                    {this.state.isTableView2 ? this.lbl('transport.show_column') : this.lbl('transport.show_card')}
                  </ButtonComponent>
                </HBox>
                <TransportOrderSearch separatePage overview={'double'} />
              </div>
            </div>

            {/* {window.innerWidth >= 1024 && this.props.count !== (null || 0) ? ( */}
            <div className="d-flex gap-2">
              <div>
                {this.state.isTableView && (
                  <tr className={cn('align-middle', s.theadMapsScreen)}>
                    <TransportOrdersOverviewMaps />
                  </tr>
                )}
                {!this.state.isTableView &&
                  (window.innerWidth >= 1024 ? (
                    <table className={cn('table', 'table-hover', 'mb-0', s.wrapper)}>
                      <thead className="align-middle">
                        <tr className={cn('align-middle', s.theadFirstScreen)}>
                          <th className={s.headTh}>
                            <CheckboxComponent
                              disabled={this.props.weblogin}
                              checked={this.state.allSelected == '1'}
                              onChange={e => {
                                if (this.state.allSelected == '1') {
                                  this.setState({ allSelected: '0' });
                                  return this.onRemoveAll(e, [...this.props.transportOrders, ...transportOrdersSecondList]);
                                }
                                this.setState({ allSelected: '1' });
                                return this.onSelectAll(e, [...this.props.transportOrders, ...transportOrdersSecondList]);
                              }}
                            />
                          </th>
                          {this.cols().map((col, index) => (
                            <th className={s.headTh} key={`${col}-${index}`} onClick={() => this.sortOn(col)}>
                              <div className={cn('d-flex gap-2 text-muted', s.spanContainer)}>
                                {col != 'financial_info' &&
                                  col != 'transporter' &&
                                  col != 'direction' &&
                                  this.renderHeaderCell(col)}

                                {!this.noSortingTypes?.includes(col) && (
                                  <Sort
                                    direction={
                                      this.getTypesTosort(this.props.filter?.sortType) == col ? this.state.direction : 'none'
                                    }
                                  />
                                )}
                              </div>
                            </th>
                          ))}
                        </tr>
                      </thead>

                      <tbody>
                        {transportOrdersToShow.filter(t => t).map(transportOrder => this.renderRow(transportOrder, '1'))}
                        {!!this.props.transportOrders?.length &&
                          this.props.paginator?.itemsCount > this.props.paginator?.limit && (
                            <div className="d-flex justify-content-center mt-2">
                              <PaginationComponent paginator={this.props.paginator} selectPage={this.selectPage} />
                            </div>
                          )}
                      </tbody>
                    </table>
                  ) : (
                    <>
                      {transportOrdersToShow
                        .filter(t => t)
                        .map(transportOrder => (
                          <div className="rows">{this.renderCard(transportOrder)}</div>
                        ))}
                    </>
                  ))}
              </div>
              <div>
                {this.state.isTableView2 && (
                  <tr className={cn('align-middle', s.theadMapsScreen)}>
                    <TransportOrdersOverviewMaps />
                  </tr>
                )}
                {!this.state.isTableView2 &&
                  (window.innerWidth >= 1024 ? (
                    <table className={cn('table', 'table-hover', 'mb-0', s.wrapper)}>
                      <thead className="align-top">
                        <tr className={cn('align-top', s.theadFirstScreen)}>
                          <th className={s.headTh}>
                            <CheckboxComponent
                              disabled={this.props.weblogin}
                              checked={this.state.allSelected == '1'}
                              onChange={e => {
                                if (this.state.allSelected == '1') {
                                  this.setState({ allSelected: '0' });
                                  return this.onRemoveAll(e, [...this.props.transportOrders, ...transportOrdersSecondList]);
                                }
                                this.setState({ allSelected: '1' });
                                return this.onSelectAll(e, [...this.props.transportOrders, ...transportOrdersSecondList]);
                              }}
                            />
                          </th>
                          {this.cols().map((col, index) => (
                            <th
                              className={s.headTh}
                              key={`${col}-${index}`}
                              onClick={() => this.sortOn(col, 'separateList')}
                            >
                              <div className={cn('d-flex gap-2 text-muted', s.spanContainer)}>
                                {col != 'financial_info' &&
                                  col != 'transporter' &&
                                  col != 'direction' &&
                                  this.renderHeaderCell(col)}

                                {!this.noSortingTypes?.includes(col) && (
                                  <Sort
                                    direction={
                                      this.getTypesTosort(this.props.filter?.sortType) == col ? this.state.direction : 'none'
                                    }
                                  />
                                )}
                              </div>
                            </th>
                          ))}
                        </tr>
                      </thead>

                      <tbody>
                        {transportOrdersSecondList.filter(t => t).map(transportOrder => this.renderRow(transportOrder, '2'))}
                        {!!this.props.transportOrdersSeparateList?.length &&
                          this.props.separateListPaginator?.itemsCount > this.props.separateListPaginator?.limit && (
                            <div className="d-flex justify-content-center mt-2">
                              <PaginationComponent
                                paginator={this.props.separateListPaginator}
                                selectPage={page => this.selectPage(page, 'separateList')}
                              />
                            </div>
                          )}
                      </tbody>
                    </table>
                  ) : (
                    <>
                      {transportOrdersSecondList
                        .filter(t => t)
                        .map(transportOrder => (
                          <div className="rows">{this.renderCard(transportOrder)}</div>
                        ))}
                    </>
                  ))}
              </div>
            </div>
          </VBox>
        </HBox>
        {console.log('Rendering Modal:', this.state.showModal, this.state.selectedTransportOrder)}
        {this.state.showModal && this.state.selectedTransportOrder && (
          <TransportOrderCreateModal
            vehicle={this.state.selectedTransportOrder.vehicle}
            transportOrderId={this.state.selectedTransportOrder.id}
            overviewButton={true}
            from_location={'overview'}
            forceOpen={true} // Pass a prop to force opening
            onClose={() => this.setState({ showModal: false, selectedTransportOrder: null })}
          />
        )}
      </div>
    );
  }

  renderCard = transportOrder => {
    const establishmentName = "In de Wal Auto's B.V.";
    const vehicle = transportOrder?.vehicle;
    const fromCompany = transportOrder?.companyFrom;
    const fromAddress = transportOrder?.addressFrom;
    const toCompany = transportOrder?.companyTo;
    const toAddress = transportOrder?.addressTo;
    const transporter = transportOrder?.transporter;

    let date =
      typeof vehicle.date_first_allowance === 'number'
        ? dayjs(vehicle.date_first_allowance).format('DD-MM-YYYY')
        : dayjs(vehicle.date_first_allowance, 'DD-MM-YYYY').format('DD-MM-YYYY');
    if (date === 'Invalid Date') {
      date = vehicle.date_first_allowance;
    }
    if (this.props.work) return <LoadingCard />;

    return (
      <CardComponent
        key={vehicle.vehicleId}
        id={`item${vehicle.vehicleId}`}
        vehicle={vehicle}
        onClick={() => {}}
        transportOrderPage
        title={
          <div className={s.cardTitle}>
            <div className={s.containerInfo}>
              <span className={s.cardInfoCar}>
                <strong>
                  {vehicle.brand_name}&nbsp;
                  {vehicle.model_name}
                </strong>
                {vehicle.power ? <> {vehicle.power} Kw</> : ''}
              </span>
              <span>{vehicle.model_info}</span>

              <div className={s.modelInfo}>
                {this.renderVehiclePaymentStatus(transportOrder?.type, vehicle)} &nbsp;
                {this.renderReleaseStatus(transportOrder?.type, vehicle)}
              </div>

              <HBox gap={8} className="mt-2">
                <VehicleStatusLabel key={`${transportOrder.id}-${transportOrder.id}`} status={3}>
                  {this.lbl('transport_order.filter.' + transportOrder.type)}
                </VehicleStatusLabel>
                <VehicleStatusLabel key={`${transportOrder.id}`} status={0}>
                  {this.lbl('transport_order.filter.' + transportOrder.status)}
                </VehicleStatusLabel>
              </HBox>
            </div>
            <VBox gap={'8px'} right className={s.containerInfo}>
              <VBox right>
                <strong>{this.lbl('transport_order.overview.column.datePlanned')}</strong>
                <strong>{getDate(transportOrder.datePlanned)}</strong>
              </VBox>
              <VBox right>
                <strong>{this.lbl('transport_order.overview.column.dateToPlan')}</strong>
                <strong>{getDate(transportOrder.dateToPlan)}</strong>
              </VBox>
            </VBox>
          </div>
        }
        label={
          <VBox right>
            <strong>{this.lbl('transport_order.overview.column.transporter')}</strong>
            <strong>{`${transporter?.name || ''} ${transporter?.surname || ''}`}</strong>
          </VBox>
        }
      >
        <div className={cn('text-muted', s.gridcompanyTod)}>
          <div className={s.gridcompanyTodColumn}>
            <h6 className={s.gridCardItem}>{<RegplateLabel regplate={vehicle.regplate} width="80" />}</h6>
            <h6 className={s.gridCardItem}>{date?.split?.('-').pop() ?? '-'}</h6>
            <h6 className={s.gridCardItem}>{parseInt(vehicle.mileage || '0').toLocaleString() + ' km'}</h6>
            {/* <h6 className={s.gridCardItem}>
              {vehicle?.transmission_type?.charAt(0).toUpperCase() + vehicle?.transmission_type?.slice(1) ?? '-'}
            </h6> */}
          </div>

          <div className={s.gridCardColumn}>
            <VBox left className={s.gridCardItem} right>
              <VBox className="address" right>
                <strong>
                  {' '}
                  {transportOrder?.companyFromManual
                    ? transportOrder?.companyFromManual
                    : fromCompany?.['company_type'] === 'company'
                    ? fromCompany?.['name'] || ''
                    : `${fromCompany?.name || ''} ${fromCompany?.surname || ''}`}
                </strong>
                <strong>{fromAddress?.addressLine1}</strong>
                <div>
                  {fromAddress?.postcode} {fromAddress?.city}
                </div>
                <div>{fromAddress?.country?.name}</div>
                <div>{parseCompanyPhoneNumber(fromCompany)}</div>
              </VBox>
              <div>
                <ArrowDown />
              </div>
            </VBox>

            <VBox left className={s.gridCardItem}>
              <VBox className="address" right>
                <strong>
                  {transportOrder?.companyToManual
                    ? transportOrder?.companyToManual
                    : toCompany['company_type'] === 'company'
                    ? toCompany['name'] || ''
                    : `${toCompany?.name || ''} ${toCompany?.surname || ''}`}
                </strong>
                <strong>{toAddress?.addressLine1}</strong>
                <div>
                  {toAddress?.postcode} {toAddress?.city}
                </div>
                <div>{toAddress?.country?.name}</div>
                <div>{parseCompanyPhoneNumber(toCompany)}</div>
              </VBox>
            </VBox>
          </div>
        </div>
        {/* <div className={s.buttonCard}>
          <div className={s.button}></div>
        </div> */}
      </CardComponent>
    );
  };

  handleClick(event, itemId) {
    this.to(`/transport-orders/${itemId}`, event?.ctrlKey || event?.metaKey);
  }

  renderRemarkText(remarks, transportOrderId) {
    if (!remarks?.length) {
      return (
        <img
          style={{ cursor: 'pointer', opacity: '0.15', marginTop: '10px', marginRight: '5px' }}
          src="https://vindat.indewal.nl/storage/documents/ca10dd49-aac5-4351-a014-a3cfeee9f88d.png"
          title=""
          width="18"
        />
      );
    }
  }

  renderOpennedTaskAlert(vehicle) {
    if (getVehicleTaskOpen(vehicle)?.length) {
      return (
        <OnMouseOverNotification
          message={
            <div className="d-flex flex-column">
              <span className="red-text">{this.lbl('kanbanboards.cell.has_open_task')}: </span>
              <span>{getVehicleTaskOpen(vehicle)[0]}</span>
            </div>
          }
          minWidth={'250px'}
          left={'0px'}
        />
      );
    }
    return null;
  }

  renderText(text) {
    return <strong>{text}</strong>;
  }

  handleTableRowClick = (event, transportOrder) => {
    event.stopPropagation();

    if (this.state.selectedTransportOrder?.id === transportOrder.id) {
      // If clicking the same transport order, close it
      this.setState({ showModal: false, selectedTransportOrder: null });
    } else {
      // Otherwise, open the modal for the new selection
      this.setState({ showModal: true, selectedTransportOrder: transportOrder });
    }
  };

  renderRow(transportOrder, screen) {
    return (
      <tr
        className={`align-middle ${s.theadFirstScreen}`}
        key={transportOrder.id}
        id={`item${transportOrder.id}`}
        onClick={event => this.handleTableRowClick(event, transportOrder)}
      >
        <td className={s.bodyTd}>
          <div className={s.checkboxContainerTd}>
            <CheckboxComponent
              disabled={this.props.weblogin}
              checked={this.isSelectedTransportOrder(transportOrder?.id)}
              onChange={e => this.onSelectTransportOrder(e, transportOrder)}
            />
          </div>
        </td>

        {this.cols().map(col => (
          <td className={s.bodyTd}>{this.renderCell(col, transportOrder)}</td>
        ))}
      </tr>
    );
  }

  renderHeaderCell(col) {
    switch (col) {
      case 'isHome':
        return '';
      default:
        return this.lbl(`transport_order.overview.column.${col}`);
    }
  }

  renderCell(col, transportOrder) {
    const establishmentName = "In de Wal Auto's B.V.";
    const vehicle = transportOrder?.vehicle;
    const fromCompany = transportOrder?.companyFrom;
    const fromAddress = transportOrder?.addressFrom;
    const toCompany = transportOrder?.companyTo;
    const toAddress = transportOrder?.addressTo;
    const transporter = transportOrder?.transporter;

    const key = `${col}-${transportOrder.id}`;

    const fn = () => {
      switch (col) {
        case 'regplate':
          if (transportOrder?.vehicleManual) {
            return '-';
          }
          return (
            <div className={cn('text-wrap', s.reglateCar)} key={key}>
              {vehicle?.regplate ? (
                <div className={s.licensePlate}>
                  <a href={`/vehicles/${vehicle?.id}`} target="_blank" rel="noopener noreferrer">
                    <RegplateLabel regplate={vehicle?.regplate} width="80" />
                  </a>
                </div>
              ) : (
                <div>{vehicle.vin?.substr(-6)}</div>
              )}

              {/* <div>ID: {vehicle.id}</div> */}
            </div>
          );

        case 'info':
          if (transportOrder?.vehicleManual) {
            return <div className={s.brandName}>{transportOrder?.vehicleManual}</div>;
          }
          return (
            <>
              <div className={cn('text-wrap', s.reglateCar)} key={`${key}-col-info`}>
                {vehicle?.regplate ? (
                  <div className={s.licensePlate}>
                    <a href={`/vehicles/${vehicle?.id}`} target="_blank" rel="noopener noreferrer">
                      <RegplateLabel regplate={vehicle?.regplate} width="80" />
                    </a>
                  </div>
                ) : (
                  <div>{vehicle.vin?.substr(-6)}</div>
                )}

                {/* <div>ID: {vehicle.id}</div> */}
              </div>

              <div key={key} className={s.gridContainer}>
                <div className={s.carInformation}>
                  <WithVehicle vehicle_id={transportOrder?.vehicleId}>
                    <div className={s.modelInfo}>
                      {vehicle.brand_name} {vehicle.model_name?.substring(0, 17)}
                    </div>
                    <div className={s.modelName}></div>
                  </WithVehicle>
                  <div className="d-flex align-items-center" style={{ gap: '5px' }}>
                    {this.renderRemarkText(transportOrder?.remarks, transportOrder?.id)}
                    {this.renderOpennedTaskAlert(vehicle)}
                    {transportOrder?.individual && (
                      <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
                        <title>Los transport</title>
                        <circle cx="6" cy="6" r="6" fill="green" />
                      </svg>
                    )}
                  </div>
                </div>
              </div>
            </>
          );
          break;

        case 'financial_info':
          return (
            <VBox className={s.modelInfo} gap={'4px'}>
              {this.renderVehiclePaymentStatus(transportOrder?.type, vehicle)}
              {this.renderReleaseStatus(transportOrder?.type, vehicle)}
            </VBox>
          );

        case 'from_company':
          return (
            <VBox left>
              <VBox className={cn(s.address)} left>
                <strong>
                  {transportOrder?.companyFromManual ||
                    (fromCompany?.['company_type'] === 'company'
                      ? fromCompany?.['name']?.substring(0, 33) || ''
                      : `${fromCompany?.name?.substring(0, 33) || ''} ${fromCompany?.surname?.substring(0, 33) || ''}`)}
                  <br />
                </strong>
                {`${fromAddress?.addressLine1?.substring(0, 17) || ''}, ${fromAddress?.city || ''}`}
              </VBox>
            </VBox>
          );
        case 'from_address':
          if (transportOrder?.addressFromManual) {
            return <>{transportOrder?.addressFromManual}</>;
          }
          return (
            <VBox left>
              <VBox className={cn(s.address)} left>
                <strong>{fromAddress?.addressLine1}</strong>
                <VBox className={cn(s.address)}>
                  {fromAddress?.postcode} {fromAddress?.city}
                </VBox>
                <VBox className={cn(s.address)}>{fromAddress?.country?.name}</VBox>
                <VBox className={cn(s.address)}>{parseCompanyPhoneNumber(fromCompany)}</VBox>
              </VBox>
            </VBox>
          );
        case 'to_company':
          return (
            <>
              <VBox left>
                <VBox className={cn(s.address)} left>
                  <strong>
                    {transportOrder?.companyToManual ||
                      (toCompany?.['company_type'] === 'company'
                        ? toCompany?.['name']?.substring(0, 33) || ''
                        : `${toCompany?.name?.substring(0, 33) || ''} ${toCompany?.surname?.substring(0, 33) || ''}`)}
                    <br />
                  </strong>
                  {`${toAddress?.addressLine1?.substring(0, 17) || ''}, ${toAddress?.city || ''}`}
                </VBox>
              </VBox>
            </>
          );
        case 'to_address':
          if (transportOrder?.addressToManual) {
            return <>{transportOrder?.addressToManual}</>;
          }
          return null;
        case 'transporter':
          return (
            <>
              <VBox className={cn(s.address)} left>{`${transporter?.name || ''}`}</VBox>
            </>
          );
        case 'datePlanned':
          return (
            <VBox gap={8}>
              <VBox className={cn(s.address)} left>
                {getDate(transportOrder.datePlanned)}
              </VBox>
            </VBox>
          );
        case 'dateToPlan':
          return (
            <VBox gap={8}>
              <VBox className={cn(s.address)} left>
                {getDate(transportOrder.dateToPlan)}
              </VBox>
            </VBox>
          );

        case 'direction':
          return (
            <VBox gap={2} className={cn(s.address)} left>
              <VehicleStatusLabel
                key={`${col}-${transportOrder.id}-${transportOrder.id}`}
                status={transportOrder?.type}
                overview={'double'}
              >
                {transportOrder?.type}
              </VehicleStatusLabel>
            </VBox>
          );

        case 'type':
          return (
            <>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '3px' }}>
                <VBox gap={2} className={cn(s.address)} left>
                  <VehicleStatusLabel
                    key={`${col}-${transportOrder.id}-${col}`}
                    status={transportOrder?.status}
                    overview={'double'}
                  >
                    {this.lbl(`transport_order.filter.${transportOrder?.status}`)}
                  </VehicleStatusLabel>
                </VBox>

                {transporter?.name && (
                  <VBox gap={2} className={cn(s.address)} center>
                    <VehicleStatusLabel
                      key={`${col}-${transportOrder.id}-${col}`}
                      status={transporter?.name}
                      overview={'double'}
                      color={'black'}
                    >
                      {this.lbl(`transport_order.filter.${transporter?.name}`)}
                    </VehicleStatusLabel>
                    {transportOrder?.datePlanned ? new Date(transportOrder.datePlanned).toLocaleDateString('nl-NL') : ''}
                  </VBox>
                )}
              </div>
            </>
          );

        case 'plan':
          return (
            // <>
            //   <VBox gap={8} onClick={event => event.stopPropagation()} key={`${col}-${transportOrder.id}`}>
            //     <TransportOrderCreateModal
            //       vehicle={transportOrder?.vehicle}
            //       transportOrderId={transportOrder?.id}
            //       overviewButton={true}
            //     />
            //   </VBox>
            // </>
            null
          );

        default:
          return vehicle[col];
      }
    };
    return (
      <div className={`col-${col}`} key={`${col}-${transportOrder.id}`}>
        {fn()}
      </div>
    );
  }
}

TransportOrdersOverviewDoubleScreenComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    transportOrders: selectTransportOrders(),
    transportOrdersSeparateList: selectTransportOrdersSeparateList(),
    filter: selectTransportOrderFilter(),
    count: selectTransportOrderCount(),
    paginator: selectTransportOrderPaginator(),
    separateListCount: selectSeparateListTransportOrderCount(),
    separateListPaginator: selectSeparateListTransportOrderPaginator(),
    separateListFilter: selectTransportOrderSeparateListFilter(),
    bulkActionsList: selectTransportOrdersBulkActionsList(),
    doubleScreen: selectOverviewScreenMode(),

    work: selectWorks([REQUEST_TRANSPORT_ORDERS]),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch: () => {
      dispatch(changeTransportOrderFilter('searchString', ''));
    },
    changeFilter: (name, value, options = {}) => {
      dispatch(changeTransportOrderFilter(name, value, options));
    },

    addTransportOrderToBulkActionsList(transportOrder) {
      dispatch(addTransportOrderToBulkActionsList(transportOrder));
    },
    removeTransportOrderFromBulkActionsList(transportOrderId) {
      dispatch(removeTransportOrderFromBulkActionsList(transportOrderId));
    },
    switchScreen() {
      dispatch(switchOverviewScreenMode());
    },

    setScrollPosition(pos) {
      dispatch(setScrollPosition(pos));
    },
    toggleNotification() {
      dispatch(toggleNotification('0'));
    },
    async setSort(type, order, separateList) {
      try {
        const result = await dispatch(setTransportOrdersSort(type, order, { separateList: separateList ?? null }));

        if (result?.type == SET_TRANSPORT_ORDERS_SORT) {
          separateList ? dispatch(applyTransportOrderSeparateListFilters()) : dispatch(applyTransportOrderFilters());
        }
      } catch (e) {}
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const TransportOrdersOverviewDoubleScreen = compose(withConnect, withRouter)(TransportOrdersOverviewDoubleScreenComp);
